export default {
    user_not_active: `Пользователь не активен или не существует`,
    fields: {
        user_id: {
            label: 'Введите идентификатор пользователя, которого вы хотите',
            placeholder: 'Введите идентификатор здесь',
        },
    },
}
